import { useEffect, useState, useMemo } from 'react';
import { usePermission } from '../contexts/PermissionContext';
import { isRouteActive } from '../utils/routeMatch';

export { isRouteActive };

const useMenuData = () => {
  const { menuTree: rawData, isMenuLoading } = usePermission();
  const [isCurrentState, setIsCurrentState] = useState('');
  const currentPath = window.location.pathname;

  useEffect(() => {
    if (!rawData.length) return;
    const findActiveParent = items => {
      for (const item of items) {
        if (isRouteActive(item.link, currentPath)) return item.code;
        if (item.children?.length) {
          const childMatch = findActiveParent(item.children);
          if (childMatch) return item.code || childMatch;
        }
      }
      return null;
    };
    const activeCode = findActiveParent(rawData);
    if (activeCode) setIsCurrentState(activeCode);
  }, [rawData, currentPath]);

  const menuItems = useMemo(() => {
    const transformData = items => {
      if (!items || !Array.isArray(items)) return [];
      let flatMenu = [];

      const sortedItems = [...items].sort(
        (a, b) => (a.orderNumber || 0) - (b.orderNumber || 0)
      );

      sortedItems.forEach(item => {
        const childrenArr = item.children || [];
        const hasChildren = childrenArr.length > 0;

        if (item.isHeader) {
          const childMenu = hasChildren ? transformData(childrenArr) : [];
          if (!childMenu.length) return;

          flatMenu.push({
            id: item.code || item.id,
            label: item.label,
            isHeader: true,
          });
          flatMenu = flatMenu.concat(childMenu);
        } else if (!item.canRead) {
          return;
        } else {
          const isParentOfCurrentPath = isRouteActive(item.link, currentPath);

          flatMenu.push({
            id: item.code || item.id,
            label: item.label,
            icon: item.icon || 'bx bx-file',
            link: item.link ? item.link : hasChildren ? '/#' : '/',
            isHeader: false,
            stateVariables:
              isCurrentState === item.code || isParentOfCurrentPath,
            isActive: isParentOfCurrentPath,
            click: function (e) {
              if (hasChildren || !item.link) {
                e.preventDefault();
                setIsCurrentState(prev =>
                  prev === item.code ? '' : item.code
                );
              }
            },
            ...(hasChildren && { subItems: transformData(childrenArr) }),
          });
        }
      });
      return flatMenu;
    };
    return transformData(rawData);
  }, [rawData, isCurrentState, currentPath]);

  return { menuItems, isCurrentState, isMenuLoading };
};

export default useMenuData;
